import PropTypes from "prop-types";
import React from "react";

// eslint-disable-next-line react/display-name
const Select = React.forwardRef((props, ref) => {
  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 overflow-ellipsis overflow-hidden">
        {props.label}
        {props.required && <span className={"ml-1 text-red-500"}>*</span>}
      </label>
      <div className="relative">
        <select
          ref={ref}
          className={`outline-none w-full text-gray-800 px-4 py-2 pr-10 rounded-theme border-gray-200 border shadow-sm focus:ring-1 focus:ring-accent overflow-auto ${
            props?.className ?? ""
          }`}
          onChange={props.onChange}
          name={props.name}
          defaultValue={props.defaultValue}
          multiple={props.multiple ?? false}
        >
          {!props.options && !props.children && <option>Loading...</option>}
          {props.placeholder && (
            <option value="" hidden>
              {props.placeholder}
            </option>
          )}
          {props.newOption && <option value="new">{props.newOption}</option>}
          {props.options &&
            props.options.map((option) => {
              if (option.name || option.value) {
                return (
                  <option key={option.value} value={option.value}>
                    {option.name || option.value}
                  </option>
                );
              } else {
                return (
                  <option key={option} value={option}>
                    {option}
                  </option>
                );
              }
            })}
          {!props.options && props.children}
        </select>
        {/*<span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">*/}
        {/*    <svg className="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">*/}
        {/*      <path d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"*/}
        {/*            clipRule="evenodd" fillRule="evenodd"/>*/}
        {/*    </svg>*/}
        {/*</span>*/}
      </div>
    </div>
  );
});

export default Select;

Select.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.any,
  newOption: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.any,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
};
